import { CoverageAvailable } from 'src/pages/phoneInsurance'

import { TypesRoutes as Routes } from './types'

export const mixedRoutes = [{ route: Routes.COVERAGE_AVAILABLE, component: CoverageAvailable }]

export * from './types'
